import React, { useEffect, useState } from 'react'
import { DataGrid as MUIDataGrid, DataGridProps, GridCellEditCommitParams } from '@mui/x-data-grid'
import moment, { isDate } from 'moment'

type Props = DataGridProps & {
  setProfessionalAthletesSelected: any
  rows: []
}

export const DataGrid = ({ setProfessionalAthletesSelected, rows, ...data }: Props) => {
  const [pageSize, setPageSize] = useState<number>(20)
  const [professionalAthletesSelectedId, setProfessionalAthletesSelectedId] = useState<any>([])
  const [rowsResult, setRowsResult] = useState<any[]>(rows)

  useEffect(() => {
    setRowsResult(rows)
  }, [rows])

  const handleCellEditCommit = async ({ id, field, value }: GridCellEditCommitParams) => {
    const index = rowsResult.findIndex(row => row.id === id)
    rowsResult[index][field] = value
    if (isDate(value)) {
      rowsResult[index][field] = moment(value).format('DD/MM/YYYY')
      if (field === 'startedAt') {
        const newDate = new Date(value)
        rowsResult[index].dueDateAt = moment(newDate.setMonth(newDate.getMonth() + 1)).format('DD/MM/YYYY')
      }
    }
    if (professionalAthletesSelectedId.length > 0) {
      const selectedRowData = rows.filter((row: any) => professionalAthletesSelectedId.has(row.id.toString()))
      setProfessionalAthletesSelected(selectedRowData)
    }
    setRowsResult(rowsResult)
  }

  return (
    <MUIDataGrid
      {...data}
      style={{
        borderTopWidth: 0.5,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        borderRadius: 0
      }}
      rows={rowsResult}
      autoHeight={true}
      rowHeight={65}
      checkboxSelection
      onCellEditCommit={handleCellEditCommit}
      disableSelectionOnClick
      rowsPerPageOptions={[20, 40, 80]}
      pagination
      pageSize={pageSize}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      onSelectionModelChange={(ids) => {
        const selectedIDs = new Set(ids)
        const selectedRowData = rowsResult.filter((row: any) =>
          selectedIDs.has(row.id.toString())
        )
        setProfessionalAthletesSelectedId(selectedIDs)
        setProfessionalAthletesSelected(selectedRowData)
      }}
    />
  )
}
